import { Card, Text, Title } from '@tremor/react'

export default function WelcomeStep() {
    return (
        <Card className="bg-transparent ring-0">
            <Title className="text-2xl text-white">
                Cloud Cost Optimization
            </Title>
            <Text className="text-md text-white">
                Enter details about your workloads step-by-step to generate
                tailored recommendations.
            </Text>
            <Text className="text-md text-white">
                Estimates are indicative, not a quote.
            </Text>
        </Card>
    )
}
